export const NUMERO_QUANTIDADE_REGISTROS = ['5', '10', '20', '50'];

export const QUANTIDADE_REGISTROS_DEFAULT = '10';

export const QUANTIDADE_REGISTROS_OPCOES = [5, 10, 20, 50];
